import {
  Option
} from "./chunk-MDHIJGDW.mjs";

// src/dropdown-menu/src/dropdown-option-value.tsx
import { jsx } from "react/jsx-runtime";
var isOptionValue = (input) => typeof input.label === "string";
var OptionValue = ({ label, ...props }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  /* @__PURE__ */ jsx(Option, { ...props, label, children: label })
);

export {
  isOptionValue,
  OptionValue
};
